import type { MessageKey } from "./ru"

export const hiMessages = {
  "common.loading": "लोड हो रहा है...",
  "common.error": "त्रुटि",
  "common.back": "वापस",
  "common.next": "आगे",
  "common.search": "खोज",
  "auth.loginErrorTitle": "लॉगिन त्रुटि",
  "auth.openViaTelegram": "ऐप को Telegram के माध्यम से खोलें",
  "auth.telegramRequired": "ऐप को Telegram के माध्यम से खोला जाना चाहिए",
  "auth.authorizationError": "प्राधिकरण त्रुटि",
  "device.rotatePortrait": "डिवाइस को लंबवत घुमाएँ",
  "country.brazil": "ब्राज़ील",
  "country.vietnam": "वियतनाम",
  "country.egypt": "मिस्र",
  "country.india": "भारत",
  "country.indonesia": "इंडोनेशिया",
  "country.iran": "ईरान",
  "country.spain": "स्पेन",
  "country.italy": "इटली",
  "country.kazakhstan": "कज़ाख़स्तान",
  "country.colombia": "कोलंबिया",
  "country.malaysia": "मलेशिया",
  "country.mexico": "मेक्सिको",
  "country.nigeria": "नाइजीरिया",
  "country.pakistan": "पाकिस्तान",
  "country.russia": "रूस",
  "country.usa": "संयुक्त राज्य अमेरिका",
  "country.turkey": "तुर्किये",
  "country.uzbekistan": "उज़्बेकिस्तान",
  "country.ukraine": "यूक्रेन",
  "country.philippines": "फ़िलीपींस",
  "countrySelection.chooseCountry": "देश चुनें",
  "countrySelection.openAria": "देश चुनें",
  "languageSelection.chooseLanguage": "भाषा चुनें",
  "commercial.direction.autotrade": "ऑटो मार्केट",
  "commercial.direction.insurance": "बीमा",
  "commercial.direction.pitstop": "पिट स्टॉप",
  "commercial.direction.techhelp": "सड़क सहायता",
  "commercial.searchLabel": "BeepApp खोज",
  "commercial.cityPlaceholder": "शहर दर्ज करें",
  "commercial.emptyTitle": "आज कोई ऑफ़र नहीं है",
  "commercial.emptyLine1": "आपके शहर में अभी कोई सक्रिय BeepApp पार्टनर नहीं है",
  "commercial.emptyLine2": "हम उन्हें खोजने और जोड़ने पर काम कर रहे हैं",
  "commercial.emptyLine3": "नए ऑफ़र यहाँ अपने-आप दिखाई देंगे",
  "commercial.helperLine1": "उपलब्ध ऑफ़र देखने के लिए",
  "commercial.helperLine2": "अपना शहर दर्ज करें",
  "commercial.partnerPrompt": "BeepApp पार्टनर बनना चाहते हैं?",
  "commercial.apply": "आवेदन करें",
  "main.admin": "एडमिन",
  "main.garage": "गैरेज",
  "main.signalSent": "सिग्नल भेज दिया गया",
  "main.partnerInviteUnavailable": "पार्टनर आमंत्रण उपलब्ध नहीं है",
  "main.enterPlate": "नंबर प्लेट दर्ज करें",
  "main.searchError": "खोज त्रुटि",
  "main.signalSendError": "सिग्नल भेजा नहीं जा सका",
  "main.shareCardPrefix": "नंबर प्लेट कार्ड",
  "main.shareLinkError": "लिंक तैयार नहीं किया जा सका",
  "main.searchByPlateAria": "नंबर प्लेट से खोजें",
  "main.russianPlateAria": "रूसी नंबर प्लेट",
  "main.plateAria": "नंबर प्लेट",
  "main.findPlateAria": "नंबर प्लेट खोजें",
  "main.loadingVehicle": "नंबर प्लेट कार्ड लोड हो रहा है…",
  "main.leaveSignal": "सिग्नल भेजें",
  "main.share": "साझा करें",
  "signalSelection.chooseType": "सिग्नल प्रकार चुनें",
  "signalSelection.category.attention": "व्यक्तिगत",
  "signalSelection.category.road": "सड़क",
  "signalSelection.category.urgent": "तत्काल",
  "signalSelection.chooseSignal": "सिग्नल चुनें",
  "signalSelection.suggestOwn": "अपना विकल्प सुझाएँ",
  "signalConfirmation.title": "सिग्नल की पुष्टि",
  "signalConfirmation.plateHeading": "वाहन नंबर जाँचें",
  "signalConfirmation.signalHeading": "चुना गया सिग्नल जाँचें",
  "signalConfirmation.replyTitle": "Telegram में जवाब की अनुमति दें",
  "signalConfirmation.replyBody": "इसे चालू करें ताकि नंबर का मालिक आपको\nTelegram में संदेश भेज सके। जवाब तभी संभव है जब\nआपके पास @username हो। जवाब देना या न देना\nनंबर के मालिक का निर्णय है।",
  "signalConfirmation.consentText": "मैं पुष्टि करता/करती हूँ कि यह सिग्नल\nवास्तविक स्थिति से संबंधित है और स्पैम\nया झूठी सूचना नहीं है।",
  "signalConfirmation.warning": "भेजने के बाद सिग्नल\nबदला नहीं जा सकेगा",
  "signalConfirmation.sending": "भेजा जा रहा है…",
  "signalConfirmation.send": "भेजें",
  "partner.loadingAria": "लोड हो रहा है",
  "partner.title": "पार्टनर प्रोग्राम",
  "partner.offerLine1": "सभी भुगतानों से अनिश्चितकाल तक 30% पाएँ",
  "partner.offerLine2": "जो आपके आमंत्रित उपयोगकर्ता BeepApp में करते हैं",
  "partner.offerLine3": "Telegram affiliate प्रोग्राम के माध्यम से",
  "partner.connectUnavailable": "Telegram Affiliate प्रोग्राम सेट होने के बाद कनेक्शन उपलब्ध होगा।",
  "partner.connectTelegram": "Telegram में कनेक्ट करें",
  "partner.qrAria": "पार्टनर लिंक QR कोड",
  "partner.download": "डाउनलोड",
  "partner.promoHeading": "व्यक्तिगत प्रोमो कोड बनाएँ",
  "partner.promoHelperLine1": "प्रोमो कोड एक अतिरिक्त वर्ष की सदस्यता सक्रिय करता है",
  "partner.promoHelperLine2": "और उपयोगकर्ताओं को आकर्षित करने में मदद करता है",
  "partner.promoAria": "प्रोमो कोड",
  "partner.affiliateHeading": "आपका affiliate लिंक",
  "partner.affiliateHelper": "व्यक्तिगत QR कोड बनाने के लिए लिंक सहेजें",
  "partner.affiliateAria": "Affiliate लिंक",
  "partner.qrNoteLine1": "QR कोड को वाहन पर,",
  "partner.qrNoteLine2": "सोशल मीडिया और विज्ञापन सामग्री में लगाया जा सकता है",
  "partner.save": "सहेजें",
  "partner.reset": "रीसेट",
  "partner.resetConfirm": "सहेजा गया affiliate लिंक रीसेट करें? प्रोमो कोड आपके पास रहेगा।",
  "partner.promoFormatError": "प्रोमो कोड में 4 से 15 अक्षर होने चाहिए।",
  "partner.affiliateHostError": "केवल t.me या telegram.me लिंक मान्य हैं।",
  "partner.affiliatePathError": "लिंक में Telegram पथ नहीं है।",
  "partner.affiliateFormatError": "अमान्य affiliate लिंक।",
  "partner.loadError": "लोड त्रुटि",
  "partner.checkInputError": "दर्ज की गई जानकारी जाँचें",
  "garageActivation.promoInvalid": "प्रोमो कोड अमान्य है",
  "garageActivation.plateOccupied": "यह नंबर प्लेट पहले से जुड़ी है",
  "garageActivation.activateError": "गैरेज सक्रिय नहीं किया जा सका",
  "garageEntry.loadJournalError": "लॉगबुक लोड नहीं हो सकी",
  "garageEntry.loadStatusesError": "स्टेटस लोड नहीं हो सके",
  "garageEntry.activationSuccess": "गैरेज सफलतापूर्वक सक्रिय हुआ",
  "garageEntry.plateAttached": "नंबर प्लेट जुड़ गई",
  "garageEntry.attachError": "नंबर प्लेट जोड़ी नहीं जा सकी",
  "garageEntry.activationNote": "अपना गैरेज सक्रिय करें",
  "garageSheet.activationTitle": "गैरेज सक्रियण",
  "garageSheet.plateHelper": "वाहन नंबर प्लेट दर्ज करें",
  "garageSheet.promoHelper": "क्या आपके पास प्रोमो कोड है?",
  "garageSheet.cleanBonusLine1": "सक्रियण के बाद आपके पास 1 घंटा होगा",
  "garageSheet.cleanBonusLine2": "मुफ़्त “क्लीन स्टार्ट” के लिए",
  "garageSheet.activationFor": "सक्रियण अवधि",
  "garageSheet.cost": "लागत",
  "garageSheet.ownerConsentLine1": "मैं पुष्टि करता/करती हूँ कि मैं",
  "garageSheet.ownerConsentLine2": "दर्ज नंबर प्लेट वाले वाहन का",
  "garageSheet.ownerConsentLine3": "मालिक हूँ।",
  "garageSheet.processing": "प्रक्रिया जारी है...",
  "garageSheet.attach": "जोड़ें",
  "garageSheet.pay": "भुगतान करें",
  "garageLifecycle.cleanTitle": "क्लीन स्टार्ट",
  "garageLifecycle.deactivateTitle": "गैरेज निष्क्रियकरण",
  "garageLifecycle.cleanWarningLine1": "नंबर प्लेट का इतिहास मिटा दिया जाएगा",
  "garageLifecycle.cleanWarningLine2": "और वापस प्राप्त नहीं किया जा सकेगा!",
  "garageLifecycle.deactivateWarningLine1": "निष्क्रिय करने के बाद सक्रिय गैरेज की",
  "garageLifecycle.deactivateWarningLine2": "सुविधाओं तक पहुँच समाप्त हो जाएगी",
  "garageLifecycle.willBeDeleted": "मिटा दिया जाएगा",
  "garageLifecycle.cleanRemovedLine1": "• लॉगबुक की सभी प्रविष्टियाँ",
  "garageLifecycle.cleanRemovedLine2": "• प्राप्त सिग्नलों का इतिहास",
  "garageLifecycle.cleanRemovedLine3": "• सार्वजनिक सिग्नल काउंटर",
  "garageLifecycle.cleanRemovedLine4": "  नंबर प्लेट कार्ड पर",
  "garageLifecycle.willRemain": "बना रहेगा",
  "garageLifecycle.cleanPreservedLine1": "• गैरेज से नंबर प्लेट का लिंक",
  "garageLifecycle.cleanPreservedLine2": "• शेष सक्रियण अवधि",
  "garageLifecycle.cleanPreservedLine3": "• चुना गया नंबर प्लेट स्टेटस",
  "garageLifecycle.cleanPreservedLine4": "• नंबर प्लेट कार्ड के कुल व्यू",
  "garageLifecycle.freeFirstHour": "पहले घंटे में मुफ़्त",
  "garageLifecycle.willBecomeUnavailable": "उपलब्ध नहीं रहेगा",
  "garageLifecycle.deactivateRemovedLine1": "• लॉगबुक",
  "garageLifecycle.deactivateRemovedLine2": "• नंबर प्लेट स्टेटस चुनना और उपयोग करना",
  "garageLifecycle.deactivateRemovedLine3": "• आप अपने-आप AutoClan छोड़ देंगे",
  "garageLifecycle.deactivateRemovedLine4": "• ऑटो मार्केट",
  "garageLifecycle.deactivateRemovedLine5": "• बीमा",
  "garageLifecycle.deactivateRemovedLine6": "• पिट स्टॉप",
  "garageLifecycle.deactivateRemovedLine7": "• सड़क सहायता",
  "garageLifecycle.deactivateRemovedLine8": "• नंबर प्लेट गैरेज से अलग हो जाएगी",
  "garageLifecycle.willRemainAvailable": "उपलब्ध रहेंगे",
  "garageLifecycle.deactivatePreservedLine1": "• साथी",
  "garageLifecycle.deactivatePreservedLine2": "• डिस्पैचर",
  "garageLifecycle.deactivatePreservedLine3": "• नंबर प्लेट से खोज और",
  "garageLifecycle.deactivatePreservedLine4": "  सार्वजनिक वाहन कार्ड देखना",
  "garageLifecycle.deactivatePreservedLine5": "• किसी भी समय गैरेज को",
  "garageLifecycle.deactivatePreservedLine6": "  फिर से सक्रिय करने की सुविधा",
  "garageLifecycle.cleanConsentLine1": "मैं इस नंबर प्लेट का पूरा इतिहास",
  "garageLifecycle.cleanConsentLine2": "मिटाने के लिए सहमति देता/देती हूँ",
  "garageLifecycle.cleanConsentLine3": "और समझता/समझती हूँ कि यह वापस नहीं आएगा।",
  "garageLifecycle.deactivateConsentLine1": "मैं निष्क्रियकरण और सक्रिय गैरेज की",
  "garageLifecycle.deactivateConsentLine2": "सभी सुविधाओं तक पहुँच समाप्त होने की",
  "garageLifecycle.deactivateConsentLine3": "पुष्टि करता/करती हूँ।",
  "garageLifecycle.clean": "साफ़ करें",
  "garageLifecycle.deactivate": "निष्क्रिय करें",
} satisfies Record<MessageKey, string>
